import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "../../../css/dashboard.css"
import axios from 'axios';
import CommonTable from "../../component/table_list/common_table";
import CommonTableRow from "../../component/table_list/common_tablerow";
import CommonTableColumn from "../../component/table_list/common_tablecolumn";
import Pagination from "react-js-pagination";
import styled from "styled-components"
import Menu from "../../component/main_menu"
import { formatDate } from "../../utils/format_date"
import { useAuthContext } from '../../common/ProtectedLayout';

function AccountDeletion(props) {

    const location = useLocation();
    const navigate = useNavigate();
    const [isValidAccess, setIsValidAccess] = useState(false); // 유효한 접근 상태

    const auth = useAuthContext();

    const [userList, setUserList] = useState([]);
    const [page, setPage] = useState(1);
    const items = 10;

    const [checkedItems, setCheckedItems] = useState([]);  // 체크박스 관리
    const [searchQuery, setSearchQuery] = useState(''); // 검색어 상태

    const hadlePageChange = (page) => {
        setPage(page);
        setCheckedItems([]); // 페이지 변경 시 체크박스 초기화
    };

    const getUserRegistDelete = async () => {
        try {
            const params = searchQuery.trim() !== '' ? { query: searchQuery } : {};
            const user_result = await axios.get('/UserRegist/DeleteTotal', { params });
            setUserList(user_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    };

    useEffect(() => {
        setIsValidAccess(true);
        getUserRegistDelete();
    }, [location.state, navigate]);

    // 유효한 접근이 아닌 경우 렌더링하지 않음
    if (!isValidAccess) {
        return null;
    }


    // function formatDate(dateString) {
    //     const dateObj = new Date(dateString);

    //     const year = dateObj.getFullYear();
    //     const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    //     const day = String(dateObj.getDate()).padStart(2, '0');
    //     const hours = String(dateObj.getHours()).padStart(2, '0');
    //     const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    //     const seconds = String(dateObj.getSeconds()).padStart(2, '0');

    //     const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    //     return formattedDate;
    // }

    // 검색 핸들러
    const handleSearch = () => {
        setPage(1);
        getUserRegistDelete();
    };

    // Enter 키 핸들러
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <div className="dashboard-container">
            <div className="content-container">
                {/* 검색 UI */}
                <SearchContainer>
                    <SearchInput
                        type="text"
                        placeholder="아이디, 탈퇴일자로 검색..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onKeyPress={handleKeyPress}
                    />
                    <SearchButton onClick={handleSearch}>검색</SearchButton>
                </SearchContainer>
                <div className="small" style={{ marginTop: '20px', textAlign: 'center' }}>
                </div>
                <div style={{ marginTop: '10px' }}>
                    <CommonTable headerTitle={['No', '아이디', '고객이름', '탈퇴사유', '탈퇴일자']}>
                        {
                            userList.slice(items * (page - 1), items * (page - 1) + items).map((item, index) => {
                                return (
                                    <CommonTableRow key={index} idx={item.idx} kind={'notDetail'} >
                                        <CommonTableColumn>{userList.length - ((page - 1) * items) - index}</CommonTableColumn>
                                        <CommonTableColumn>{item.email_id}</CommonTableColumn>
                                        <CommonTableColumn>{item.user_name || '-'}</CommonTableColumn>
                                        <CommonTableColumn>{item.description === '10~400자 이내로 입력해주세요' ? '-' : item.description}</CommonTableColumn>
                                        <CommonTableColumn>{formatDate(item.date)}</CommonTableColumn>
                                    </CommonTableRow>
                                )
                            })
                        }
                    </CommonTable>
                </div>
                <PaginationBox>
                    <Pagination
                        activePage={page}
                        itemsCountPerPage={items}
                        totalItemsCount={userList.length}
                        pageRangeDisplayed={10}
                        onChange={hadlePageChange}>
                    </Pagination>
                </PaginationBox>
            </div>
        </div >
    )
}


const PaginationBox = styled.div`
  .pagination { display: flex; justify-content: center; margin-top: 15px;}
  ul { list-style: none; padding: 0; }
  ul.pagination li {
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 1px solid #e2e2e2;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem; 
  }
  ul.pagination li:first-child{ border-radius: 5px 0 0 5px; }
  ul.pagination li:last-child{ border-radius: 0 5px 5px 0; }
  ul.pagination li a { text-decoration: none; color: #337ab7; font-size: 1rem; }
  ul.pagination li.active a { color: white; }
  ul.pagination li.active { background-color: #337ab7; }
  ul.pagination li a:hover,
  ul.pagination li a.active { color: blue; }
`

const SearchContainer = styled.div`
    display: flex;
    gap: 10px;
    margin-top: 40px;
    margin-bottom: 10px;
    margin-left: 5%;
    width: auto;
    max-width: 500px;
`;

const SearchInput = styled.input`
    flex: 1;
    padding: 12px 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-size: 15px;
    transition: border-color 0.2s;
    
    &:focus {
        outline: none;
        border-color: #006edc;
    }
    
    &::placeholder {
        color: #999;
    }
`;

const SearchButton = styled.button`
    padding: 12px 24px;
    background-color: #006edc;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    
    &:hover {
        background-color: #0056b3;
        box-shadow: 0 4px 8px rgba(0,0,0,0.15);
    }
`;

export default AccountDeletion;
